export const images =[

  {
    thumbnail:"../wallpapers/wallpaper1.jpg"
  },
  {
    thumbnail:"../wallpapers/wallpaper2.jpg"
  },
  {
    thumbnail:"../wallpapers/wallpaper3.jpg"
  },
  {
    thumbnail:"../wallpapers/wallpaper4.jpg"
  },
  {
    thumbnail:"../wallpapers/wallpaper5.jpg"
  },
  {
    thumbnail:"../wallpapers/wallpaper6.jpg"
  },
  {
    thumbnail:"../wallpapers/wallpaper7.jpg"
  },
  {
    thumbnail:"../wallpapers/wallpaper8.jpg"
  },
  {
    thumbnail:"../wallpapers/wallpaper9.jpg"
  },
  {
    thumbnail:"../wallpapers/wallpaper10.jpg"
  },
  {
    thumbnail:"../wallpapers/wallpaper11.jpg"
  },

]